/* QuadrantContentComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./QuadrantContentRenderer");
const _ = require("lodash");

class QuadrantContentComponent extends EventEmitter {
    constructor(config) {
        super();
        this._location = config.quadrant;
        this._state = config.state;
        this._renderer = new Renderer(this);
        this._openedPart = undefined;
        this._swapping = false;
        this._fullScreen = false;

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {
        this._state.on("sizeChanged", () => {
            this.notifyPartSizeChanged();
        });
    }

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._state = null;
        this._renderer = null;
        return prom;
    }

    set swapping(val) {
        this._swapping = val;
    }

    get swapping() {
        return this._swapping;
    }

    getOpenedPartId() {
        return this._state.openedPartId;
    }

    getOpenedPartInfo() {
        return this._state.getActivePart(this.renderedPartId);
    }

    getPartIconClassname(name) {
        return this._state.getActivePart(name).iconClassName;
    }

    set openedPart(part) {
        this._openedPart = part;
    }

    get openedPart() {
        return this._openedPart;
    }

    set renderedPartId(id) {
        this._renderedPartId = id;
    }

    get renderedPartId() {
        return this._renderedPartId;
    }

    toggleFullScreen() {
        this.setFullScreen(!this.fullScreen);
    }

    setFullScreen(val) {
        this._fullScreen = val;
    }

    get fullScreen() {
        return this._fullScreen;
    }

    set fullScreen(val) {
        this.setFullScreen(val);
    }

    notifyPartSizeChanged() {
        if (_.get(this.openedPart, "onContainerSizeChange")) {
            this.openedPart.onContainerSizeChange(
                this.renderer.rootElement.getBoundingClientRect()
            );
        }
    }

    partHeaderDoubleClicked() {
        this._state.toggleFullScreen();
    }

    showPart(part, partId, fullScreen) {
        if (!this.swapping) {
            this.fullScreen = fullScreen;
            this.openedPart = part;
            this.renderedPartId = partId;
            return this.renderer.render();
        }
    }

    removePart(fullscreen) {
        if (!this.swapping) {
            let lastPart = this.openedPart;
            this.openedPart = null;
            this.renderedPartId = null;
            this.fullScreen = fullscreen;
            return Promise.resolve()
                .then(() => {
                    return this.renderer.render();
                })
                .then(() => {
                    return lastPart;
                });
        }
    }

    closePartClicked() {
        this._state.openedPartId = null;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */

    /*******************************************/
    async whenSwappingIsFinished() {
        // jshint ignore:line
        if (this.swapping === false) {
            return Promise.resolve();
        } else {
            for (let msWaited = 0; msWaited < 2000; msWaited += 50) {
                await sleep(50); // jshint ignore:line
                if (this.swapping === false) {
                    return Promise.resolve();
                }
            }

            return Promise.reject(
                "Can't finish QuadrantContentComponent.whenSwappingIsFinished(), timeout"
            );
        }

        function sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        }
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = QuadrantContentComponent;
